import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navigation from '../Navigation/Navigation';
import Sidebar from '../SideBar/SideBar';
import Footer from '../Footer/Footer';
import RequireAuth from '../guards/RequireAuth';
import { orgNavLinks, userNavLinks } from '../../config/sidebarLinks';

function getNavigationLinks(pathname) {
  if (pathname.startsWith('/org/')) {
    const orgId = pathname.match(/^\/org\/(\d+)/)?.[1];
    return orgId
      ? orgNavLinks.map((link) => ({
          ...link,
          to: link.to.replace(':orgId', orgId),
        }))
      : orgNavLinks;
  }

  if (
    pathname.startsWith('/conversation-type') ||
    pathname.startsWith('/practice-history') ||
    pathname.startsWith('/training-sessions')
  ) {
    return userNavLinks;
  }

  return [];
}

function AuthenticatedShell({ immersive }) {
  const location = useLocation();
  const isConversationType = location.pathname.startsWith('/conversation-type');
  const navLinks = immersive ? [] : getNavigationLinks(location.pathname);

  return (
    <>
      {!immersive && <Navigation />}
      <div className={`dashboard-root ${immersive ? '' : 'dashboard-root--app-shell'}`}>
        {!immersive && <Sidebar navLinks={navLinks} />}
        <Outlet />
      </div>
      {!immersive && !isConversationType && <Footer />}
    </>
  );
}

export default function AuthenticatedLayout({ immersive = false }) {
  return (
    <RequireAuth>
      <AuthenticatedShell immersive={immersive} />
    </RequireAuth>
  );
}
